import Component from '@galactic-advisors/component-loader';
import axios from 'axios';

const DEFAULTS = {
  generateEvidenceReportButtonElement:
    '[data-company-implementation-generate-evidence-button]',
  generateEvidenceRoute: '[data-generate-evidence-route]',
  evidenceReportStatusRoute: '[data-evidence-report-status-route]',
  generateEvidenceReportButtonText: '[data-generate-evidence-button-text]',
  toastMessageContainerElement: '[data-toast-message-container]',
  toastMessageElement: '[data-toast-message]',
  loaderElement: '[data-loader]',
  pageRefreshButtonElement: '[data-page-refresh-button]',
};

export default class CompanyImplementationEvidences extends Component {
  static selector = '[data-comp-company-implementation-evidences]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.generateEvidenceReportButton = this.$container.querySelector(
      this.$options.generateEvidenceReportButtonElement
    );

    this.generateEvidenceReportButtonText = this.$container.querySelector(
      this.$options.generateEvidenceReportButtonText
    );

    this.evidenceReportStatusRoute =
      this.generateEvidenceReportButton.dataset.evidenceReportStatusRoute;

    this.generateEvidenceRoute =
      this.generateEvidenceReportButton.dataset.generateEvidenceRoute;

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.toastMessageContainer = this.$container.querySelector(
      this.$options.toastMessageContainerElement
    );

    this.pageRefreshButton = this.$container.querySelector(
      this.$options.pageRefreshButtonElement
    );
    this.toastMessage = this.$container.querySelector(
      this.$options.toastMessageElement
    );

    this.init();
    this.startStatusInterval();
  }

  fetchJobStatus() {
    const generationStatus = axios({
      method: 'post',
      url: this.evidenceReportStatusRoute,
    }).catch((error) => {
      console.log(error.data.message);
    });
    return generationStatus;
  }

  requestEvidenceReportGeneration() {
    const generationRequest = axios({
      method: 'get',
      url: this.generateEvidenceRoute,
    })
      .then(() => {
        this.showToast('Requested Evidence Report Generation!');
      })
      .catch((error) => {
        this.showToast(error.response.data.message);
        console.error({ error });
      });
    return generationRequest;
  }

  fetchLatestReportGenerationStatus() {
    return this.fetchJobStatus().then((response) => {
      if (response && !response.data.data) {
        return false;
      }

      this.updateGenerationStatus(
        response.data.data.status,
        response.data.data.date
      );

      return response.data.data.status;
    });
  }

  refreshPage() {
    window.location.reload();
  }

  updateGenerationStatus(status, statusDate) {
    this.generateEvidenceReportButtonText.innerText = `Report Status: ${status}`;

    if (status === 'Finished') {
      this.loader.classList.add('d-none');
      this.generateEvidenceReportButton.disabled = false;
      this.generateEvidenceReportButtonText.innerText =
        'Generate Evidence Report';
    }

    if (status !== 'Finished') {
      this.loader.classList.remove('d-none');
      this.generateEvidenceReportButton.disabled = true;
    }

    if (status === 'Failed') {
      this.loader.classList.add('d-none');
      this.generateEvidenceReportButton.disabled = false;
      this.generateEvidenceReportButtonText.innerText = 'Retry Generation';
    }

    this.generateEvidenceReportButtonText.title = `Latest status date: ${statusDate}`;
  }

  showToast(status) {
    this.toastMessageContainer.classList.remove('d-none');
    this.toastMessage.innerText = status;

    setTimeout(() => {
      this.toastMessageContainer.classList.add('d-none');
    }, 2000);
  }

  startStatusInterval() {
    const runStatusUpdateInterval = async () => {
      const status = await this.fetchLatestReportGenerationStatus();
      if (status === 'Queued' || status === 'Executing') {
        setTimeout(runStatusUpdateInterval, 10000);
      }
    };
    runStatusUpdateInterval();
  }

  init() {
    this.fetchLatestReportGenerationStatus();
    this.generateEvidenceReportButton.addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        this.pageRefreshButton.classList.add('d-none');
        this.requestEvidenceReportGeneration().then(async () => {
          const res = await this.fetchJobStatus();
          this.updateGenerationStatus(res.data.data.status, res.data.data.date);
          this.pageRefreshButton.classList.remove('d-none');
          this.startStatusInterval();
        });
      }
    );
    this.pageRefreshButton &&
      this.pageRefreshButton.addEventListener('click', () => {
        this.refreshPage();
      });
  }
}
